import { useState, useEffect } from 'react';
import { SettingCard, SettingField, SettingActions, useSettingEditing } from './SettingControls';
import butterflyApi from "../../ButterflyApi";

const DOG_NAME_FEATURE_NO = 2
const DOG_LOOK_FEATURE_NO = 3
const CAT_NAME_FEATURE_NO = 18
const CAT_LOOK_FEATURE_NO = 19


const PetSetting = ({ heroNo, petKindName, setLoading, editing, setEditing }) => {

  const [name, setName] = useState('')
  const [nameFeatureContentNo, setNameFeatureContentNo] = useState(0)
  const [look, setLook] = useState('')
  const [lookFeatureContentNo, setLookFeatureContentNo] = useState(0)
  const [originFeature, setOriginFeature] = useState()
  const [updated, setUpdated] = useState(false)

  const load = async () => {
    if (!heroNo) {
      return
    }
    const nameFeatureNo = petKindName == '강아지' ? DOG_NAME_FEATURE_NO : CAT_NAME_FEATURE_NO
    const lookFeatureNo = petKindName == '강아지' ? DOG_LOOK_FEATURE_NO : CAT_LOOK_FEATURE_NO
    const data = await butterflyApi.getHeroFeatures(heroNo)
    const nameFeature = data.items.filter(item => item.heroFeatureNo == nameFeatureNo)[0]
    const lookFeature = data.items.filter(item => item.heroFeatureNo == lookFeatureNo)[0]
    setName(nameFeature?.answer || '')
    setNameFeatureContentNo(nameFeature?.heroFeatureContentNo)
    setLook(lookFeature?.answer || '')
    setLookFeatureContentNo(lookFeature?.heroFeatureContentNo)
    setOriginFeature({
      name: nameFeature?.answer || '',
      look: lookFeature?.answer || ''
    })
  }

  const onCancel = () => {
    setLook(originFeature.look)
    setName(originFeature.name)
  }

  const onSave = async () => {
    const models = []
    if (name) {
      models.push({
        heroFeatureContentNo: nameFeatureContentNo,
        answer: name,
        ordering: 1,
        heroFeatureNo: petKindName == '강아지' ? DOG_NAME_FEATURE_NO : CAT_NAME_FEATURE_NO
      })
    }
    if (look) {
      models.push({
        heroFeatureContentNo: lookFeatureContentNo,
        answer: look,
        ordering: 1,
        heroFeatureNo: petKindName == '강아지' ? DOG_LOOK_FEATURE_NO : CAT_LOOK_FEATURE_NO
      })
    }
    setLoading(true)
    await butterflyApi.updateHeroFeatures(heroNo, models)
    await load()
    setLoading(false)
    setUpdated(false)
  }

  useEffect(() => {
    load();
  }, [heroNo])

  useEffect(() => {
    if (!originFeature) {
      return
    }
    if (name != originFeature.name) {
      setUpdated(true)
      return
    }
    if (look != originFeature.look) {
      setUpdated(true)
      return
    }
    setUpdated(false)
  }, [name, look, originFeature])

  useSettingEditing(updated, setEditing)

  return <SettingCard label={petKindName} updated={updated} disabled={editing && !updated}>
    <SettingField label="이름" value={name} placeholder={`${petKindName}의 이름`} onChange={e => setName(e.target.value)} />
    <SettingField label="어떻게 생겼나요?" as="textarea" rows={2} value={look} placeholder={petKindName === '강아지' ? '예: 하얀 털에 귀가 쫑긋한 작은 강아지' : '예: 노란 털에 초록 눈을 가진 고양이'} onChange={e => setLook(e.target.value)} />
    {updated && <SettingActions onSave={onSave} onCancel={onCancel} />}
  </SettingCard>
}

export default PetSetting
